import api from './api';

const API_URL = '/sodibuong'; // Relative URL for this service

export interface SoDiBuongListItem {
    maphieu: number;
    ngay: string;
    tenKhoa: string;
    tenNvkt: string;
}

export interface SoDiBuongDanhGia {
    iddanhgia: number;
    tendanhgia: string;
}

export interface SaveSoDiBuongRequest {
    ngay: string;
    manvkt?: string;
    makhoa: number;
    loai: number;
    tongbn?: number;
    sobnc1?: number;
    sobnc2?: number;
    sobnc3?: number;
    thnhanluc?: number;
    bsdilam?: number;
    tongddktv?: number;
    maddnghitruc?: string;
    maddnghiphep?: string;
    maddctac?: string;
    maddnghisinh?: string;
    maddnghikl?: string;
    soddtangcuong?: number;
    sodddilam?: number;
    maddtruc?: string;
    thyl?: number;
    capthuoc?: number;
    congkhaithuoc?: number;
    kettcp?: number;
    ghitenthuoc?: number;
    kimluu?: number;
    xetiem?: number;
    ghihs?: number;
    huongdan?: number;
    phoihopdn?: number;
    giaotiep?: number;
    tuvanvv?: number;
    tuvanrv?: number;
    tutheodoi?: number;
    rttq?: number;
    ktchamsoc?: number;
    xulydungcu?: number;
    plrac?: number;
    bb5s?: number;
    thannhanbn?: number;
    dongphucbn?: number;
    ttb?: number;
    changagoi?: number;
    oxy?: number;
    tulanh?: number;
    suachuacsvc?: number;
    tietkiem?: number;
    luuy?: string;
}

export interface SoDiBuongDto extends SaveSoDiBuongRequest {
    maphieu: number;
    tenNvkt?: string;
    tenKhoa?: string;
    tenDdnghiphep?: string;
    tenDdctac?: string;
    tenDdnghisinh?: string;
    tenDdnghikl?: string;
    tenDdtruc?: string;
    tenDdnghitruc?: string;
}

export interface SoDiBuongReportDto {
    criteriaName: string;
    criteriaKey: string;
    departmentValues: { [key: string]: string };
    total: string;
}

// Not directly used by frontend, but good for type definition
export interface SoDiBuongDepartmentSummaryDto {
    makhoa: number;
    tenKhoa: string;
    loai: number;
    // Integer/Decimal Sums
    tongbn_sum?: number;
    sobnc1_sum?: number;
    sobnc2_sum?: number;
    sobnc3_sum?: number;
    thnhanluc_sum?: number;
    bsdilam_sum?: number;
    tongddktv_sum?: number;
    soddtangcuong_sum?: number;
    sodddilam_sum?: number;
    tuvanvv_sum?: number;
    tuvanrv_sum?: number;
    tutheodoi_sum?: number;

    // Employee Counts
    manvkt_count?: number;
    maddnghitruc_count?: number;
    maddnghiphep_count?: number;
    maddctac_count?: number;
    maddnghisinh_count?: number;
    maddnghikl_count?: number;
    maddtruc_count?: number;

    // Evaluation Counts (example for one field)
    thyl_count_1?: number;
    thyl_count_2?: number;
    thyl_count_3?: number;
    // ... and so on for all evaluation fields
}

export const soDiBuongService = {
    getAll: (fromDate: string, toDate: string, makhoa?: number, loai: number = 1) =>
        api.get<SoDiBuongListItem[]>(`${API_URL}?fromDate=${fromDate}&toDate=${toDate}&makhoa=${makhoa || 0}&loai=${loai}`),
    getById: (id: number) =>
        api.get<SoDiBuongDto>(`${API_URL}/${id}`),
    create: (request: SaveSoDiBuongRequest) =>
        api.post<SoDiBuongDto>(API_URL, request),
    update: (id: number, request: SaveSoDiBuongRequest) =>
        api.put<SoDiBuongDto>(`${API_URL}/${id}`, request),
    delete: (id: number) =>
        api.delete(`${API_URL}/${id}`),
    getAllDanhGia: () =>
        api.get<SoDiBuongDanhGia[]>(`${API_URL}/danhgia`),
    getReport: (fromDate: string, toDate: string, loai: number = 1) =>
        api.get<SoDiBuongReportDto[]>(`${API_URL}/report?fromDate=${fromDate}&toDate=${toDate}&loai=${loai}`),
};